import Component from './Table';

export default function Table(props) {
  return Component({
    ...props,
  });
}
